/* =========================================================================
   Caraïbes Audio — scripts du thème
   ========================================================================= */
(function () {
  'use strict';

  var routes = (window.theme && window.theme.routes) || {};
  var strings = (window.theme && window.theme.strings) || {};

  /* ---------- Utilitaires ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '{{amount}}';
    var value = (cents / 100);
    var out;
    if (format.indexOf('amount_no_decimals') > -1) {
      out = value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else if (format.indexOf('amount_with_comma_separator') > -1) {
      out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, '.');
    } else {
      out = value.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d),)/g, ' ');
    }
    return format.replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  var toastTimer;
  function toast(message) {
    var el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-visible'); }, 3200);
  }
  window.themeToast = toast;

  function lockScroll(state) {
    document.documentElement.classList.toggle('body-lock', state);
    document.body.classList.toggle('body-lock', state);
  }

  /* Enregistre un écouteur global une seule fois.
     init() est rappelé à chaque shopify:section:load / :select : sans ce garde,
     les gestionnaires délégués se cumulaient (le « + » de quantité ajoutait 2,
     puis 3, puis 4… et le panier se mettait à jour plusieurs fois). */
  var globalBound = {};
  function onGlobal(key, target, type, handler, opts) {
    if (globalBound[key]) return;
    globalBound[key] = true;
    target.addEventListener(type, handler, opts);
  }

  function trapFocus(container) {
    if (!container) return;
    var focusable = container.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (focusable.length) focusable[0].focus();
  }

  /* ---------- En-tête collant ---------- */
  function initStickyHeader() {
    var onScroll = function () {
      var wrapper = $('.header-wrapper');
      if (wrapper) wrapper.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onGlobal('sticky-scroll', window, 'scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Menus déroulants ---------- */
  function initNav() {
    $$('.nav__item--has-children').forEach(function (item) {
      var link = $('.nav__link', item);
      var closeTimer;
      item.addEventListener('mouseenter', function () {
        clearTimeout(closeTimer);
        item.classList.add('is-open');
        if (link) link.setAttribute('aria-expanded', 'true');
      });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () {
          item.classList.remove('is-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        }, 120);
      });
      item.addEventListener('focusin', function () { item.classList.add('is-open'); });
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) item.classList.remove('is-open');
      });
    });

    onGlobal('nav-esc', document, 'keydown', function (e) {
      if (e.key === 'Escape') $$('.nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); });
    });
  }

  /* ---------- Menu mobile ---------- */
  function initMobileMenu() {
    function menuEl() { return $('.mobile-menu'); }

    function open() {
      var menu = menuEl();
      if (!menu) return;
      menu.classList.add('is-open');
      lockScroll(true);
      trapFocus(menu);
    }
    function close() {
      var menu = menuEl();
      if (!menu) return;
      menu.classList.remove('is-open');
      lockScroll(false);
    }

    onGlobal('mobile-click', document, 'click', function (e) {
      if (e.target.closest('[data-mobile-menu-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-mobile-menu-close]') || e.target.classList.contains('mobile-menu__overlay')) close();
      var toggle = e.target.closest('[data-mobile-submenu]');
      if (toggle) {
        e.preventDefault();
        var parent = toggle.closest('.mobile-nav__item');
        if (parent) parent.classList.toggle('is-open');
      }
    });

    onGlobal('mobile-esc', document, 'keydown', function (e) {
      var menu = menuEl();
      if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) close();
    });
  }

  /* ---------- Recherche ---------- */
  function initSearch() {
    var modal = $('.search-modal');
    if (!modal) return;
    var input = $('input[type="search"]', modal);
    var results = $('[data-predictive-results]', modal);
    var timer;

    function open() {
      modal.classList.add('is-open');
      lockScroll(true);
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() { modal.classList.remove('is-open'); lockScroll(false); }

    onGlobal('search-click', document, 'click', function (e) {
      if (e.target.closest('[data-search-open]')) { e.preventDefault(); open(); }
      if (e.target.closest('[data-search-close]') || e.target.classList.contains('search-modal__overlay')) close();
    });
    onGlobal('search-esc', document, 'keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    if (!input || !results || !routes.predictive_search_url) return;
    if (globalBound['search-input']) return;
    globalBound['search-input'] = true;

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { results.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = routes.predictive_search_url +
          '?q=' + encodeURIComponent(q) +
          '&resources[type]=product,collection,page,article&resources[limit]=6' +
          '&section_id=predictive-search';
        fetch(url)
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var frag = doc.querySelector('[data-predictive-inner]');
            results.innerHTML = frag ? frag.innerHTML : '';
          })
          .catch(function () { results.innerHTML = ''; });
      }, 260);
    });
  }

  /* ---------- Panier ---------- */
  function getSectionsToRender() {
    /* Sur la page panier, on rafraîchit aussi la section principale (clé « main »
       de templates/cart.json) pour éviter un rechargement complet. */
    if (document.body.classList.contains('template--cart')) return ['cart-drawer', 'main'];
    return ['cart-drawer'];
  }

  function refreshCartUI(state) {
    if (!state) return;
    var count = state.item_count;
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = false;
    });
    if (!state.sections) return;

    if (state.sections['cart-drawer']) {
      var drawer = $('[data-cart-drawer-content]');
      if (drawer) {
        var doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
        var inner = doc.querySelector('[data-cart-drawer-content]');
        if (inner) drawer.innerHTML = inner.innerHTML;
      }
    }

    if (state.sections['main']) {
      var target = document.getElementById('shopify-section-main');
      if (target) {
        var pageDoc = new DOMParser().parseFromString(state.sections['main'], 'text/html');
        var fresh = pageDoc.getElementById('shopify-section-main');
        if (fresh) target.innerHTML = fresh.innerHTML;
      }
    }
  }

  function openCartDrawer() {
    var drawer = $('.cart-drawer');
    if (!drawer) return;
    drawer.classList.add('is-open');
    lockScroll(true);
  }
  function closeCartDrawer() {
    var drawer = $('.cart-drawer');
    if (!drawer) return;
    drawer.classList.remove('is-open');
    lockScroll(false);
  }

  function initCart() {
    onGlobal('cart-click', document, 'click', function (e) {
      if (e.target.closest('[data-cart-open]')) {
        if (window.theme && window.theme.cartType === 'drawer') {
          e.preventDefault();
          openCartDrawer();
        }
      }
      if (e.target.closest('[data-cart-close]') || e.target.classList.contains('cart-drawer__overlay')) {
        closeCartDrawer();
      }
      var remove = e.target.closest('[data-cart-remove]');
      if (remove) {
        e.preventDefault();
        updateCartLine(remove.getAttribute('data-cart-remove'), 0);
      }
    });

    onGlobal('cart-esc', document, 'keydown', function (e) {
      if (e.key === 'Escape') closeCartDrawer();
    });

    /* Ajout au panier en AJAX */
    onGlobal('cart-submit', document, 'submit', function (e) {
      var form = e.target.closest('form[data-ajax-cart]');
      if (!form) return;
      e.preventDefault();
      var button = form.querySelector('[type="submit"]');
      var original = button ? button.innerHTML : '';
      if (button) { button.classList.add('is-loading'); button.disabled = true; }

      var data = new FormData(form);
      data.append('sections', getSectionsToRender().join(','));

      fetch(routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Accept': 'application/javascript' },
        body: data
      })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status && res.status !== 200) {
            toast(res.description || res.message || strings.error);
            return;
          }
          /* /cart.js ignore le paramètre « sections » : on réutilise donc
             celles que /cart/add.js vient de renvoyer, sinon le tiroir restait
             sur son ancien contenu jusqu'au rechargement de la page. */
          return fetch(routes.cart_url + '.js')
            .then(function (r) { return r.json(); })
            .then(function (state) {
              state.sections = res.sections;
              refreshCartUI(state);
              if (window.theme && window.theme.cartType === 'drawer') {
                openCartDrawer();
              } else {
                toast(strings.added || 'Ajouté au panier');
              }
            });
        })
        .catch(function () { toast(strings.error || 'Une erreur est survenue'); })
        .finally(function () {
          if (button) { button.classList.remove('is-loading'); button.disabled = false; button.innerHTML = original; }
        });
    });
  }

  function updateCartLine(key, quantity) {
    fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: getSectionsToRender().join(',') })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        refreshCartUI(state);
      })
      .catch(function () { toast(strings.error); });
  }

  /* ---------- Sélecteurs de quantité ---------- */
  function initQuantity() {
    onGlobal('qty-click', document, 'click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      e.preventDefault();
      var wrapper = btn.closest('.quantity');
      var input = wrapper && wrapper.querySelector('input');
      if (!input) return;
      var step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
      var min = parseInt(input.getAttribute('min') || '1', 10);
      var value = Math.max(min, (parseInt(input.value, 10) || min) + step);
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    onGlobal('qty-change', document, 'change', function (e) {
      var input = e.target.closest('[data-cart-quantity]');
      if (!input) return;
      updateCartLine(input.getAttribute('data-cart-quantity'), parseInt(input.value, 10) || 0);
    });
  }

  /* ---------- Carrousels ---------- */
  function initCarousels() {
    $$('[data-carousel]').forEach(function (carousel) {
      if (carousel.getAttribute('data-carousel-bound')) return;
      carousel.setAttribute('data-carousel-bound', '1');
      var viewport = $('[data-carousel-viewport]', carousel);
      var prev = $('[data-carousel-prev]', carousel);
      var next = $('[data-carousel-next]', carousel);
      if (!viewport) return;

      function step() {
        var first = viewport.firstElementChild;
        if (!first) return viewport.clientWidth;
        var gap = parseFloat(getComputedStyle(viewport).columnGap || '20') || 20;
        return first.getBoundingClientRect().width + gap;
      }
      function update() {
        var max = viewport.scrollWidth - viewport.clientWidth - 2;
        if (prev) prev.classList.toggle('is-hidden', viewport.scrollLeft <= 2);
        if (next) next.classList.toggle('is-hidden', viewport.scrollLeft >= max);
      }
      if (prev) prev.addEventListener('click', function () { viewport.scrollLeft -= step(); });
      if (next) next.addEventListener('click', function () { viewport.scrollLeft += step(); });
      viewport.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ---------- Galerie produit ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (!slides.length) return;
      var index = 0;

      function show(i) {
        index = (i + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-active', k === index); });
        thumbs.forEach(function (t, k) {
          t.classList.toggle('is-active', k === index);
          t.setAttribute('aria-current', k === index ? 'true' : 'false');
        });
      }

      /* Exposé pour que le sélecteur de variante puisse demander une image. */
      gallery.showIndex = show;

      thumbs.forEach(function (t, k) {
        t.addEventListener('click', function (e) { e.preventDefault(); show(k); });
      });
      var prev = $('[data-gallery-prev]', gallery);
      var next = $('[data-gallery-next]', gallery);
      if (prev) prev.addEventListener('click', function () { show(index - 1); });
      if (next) next.addEventListener('click', function () { show(index + 1); });

      var zoom = $('[data-gallery-zoom]', gallery);
      var lightbox = $('[data-lightbox]');
      if (zoom && lightbox) {
        zoom.addEventListener('click', function () {
          var active = slides[index].querySelector('img');
          var target = $('[data-lightbox-image]', lightbox);
          var existing = $('img', lightbox);
          if (active && target) {
            target.innerHTML = '';
            var full = document.createElement('img');
            full.src = active.getAttribute('data-zoom-src') || active.src;
            full.alt = active.alt || '';
            target.appendChild(full);
          } else if (active && existing) {
            existing.src = active.getAttribute('data-zoom-src') || active.src;
            existing.alt = active.alt || '';
          }
          lightbox.classList.add('is-open');
          lockScroll(true);
        });
        lightbox.addEventListener('click', function (e) {
          if (e.target === lightbox || e.target.closest('[data-lightbox-close]')) {
            lightbox.classList.remove('is-open');
            lockScroll(false);
          }
        });
      }
      show(0);
    });
  }

  /* ---------- Onglets ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      /* Un drapeau porté par l'élément : on ne recolle pas les écouteurs à
         chaque shopify:section:load, mais un nouvel élément est bien relié. */
      if (root.getAttribute('data-tabs-bound')) return;
      root.setAttribute('data-tabs-bound', '1');

      var tabs = $$('[data-tab]', root);
      var panels = $$('[data-tab-panel]', root);

      function activate(id) {
        tabs.forEach(function (t) { t.setAttribute('aria-selected', t.getAttribute('data-tab') === id ? 'true' : 'false'); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-tab-panel') === id); });
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () { activate(tab.getAttribute('data-tab')); });
      });

      document.addEventListener('click', function (e) {
        var jump = e.target.closest('[data-tab-jump]');
        if (!jump || !root.contains(document.getElementById(jump.getAttribute('data-tab-jump')) || root)) {
          if (!jump) return;
        }
        var id = jump.getAttribute('data-tab-jump');
        if (tabs.some(function (t) { return t.getAttribute('data-tab') === id; })) {
          e.preventDefault();
          activate(id);
          root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* ---------- Filtres de collection ---------- */
  function initFacets() {
    /* Groupes repliables */
    onGlobal('facets-click', document, 'click', function (e) {
      var toggle = e.target.closest('.facets__group-toggle');
      if (toggle) {
        var group = toggle.closest('.facets__group');
        if (group) {
          group.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', group.classList.contains('is-open') ? 'true' : 'false');
        }
      }
      var more = e.target.closest('.facets__more');
      if (more) {
        e.preventDefault();
        var list = more.previousElementSibling;
        if (list) list.classList.toggle('is-expanded');
        more.classList.toggle('is-expanded');
        var label = more.querySelector('span');
        if (label) label.textContent = more.classList.contains('is-expanded') ? 'Voir moins' : 'Voir plus';
      }
      if (e.target.closest('[data-facets-open]')) {
        var panel = $('.facets');
        if (panel) { panel.classList.add('is-open'); lockScroll(true); }
      }
      if (e.target.closest('[data-facets-close]')) {
        var p = $('.facets');
        if (p) { p.classList.remove('is-open'); lockScroll(false); }
      }
    });

    /* Soumission automatique */
    var form = $('[data-facets-form]');
    if (form && !form.getAttribute('data-facets-bound')) {
      form.setAttribute('data-facets-bound', '1');
      form.addEventListener('change', function (e) {
        if (e.target.matches('input[type="range"]')) return;
        /* Le filtre de disponibilité du thème est traité dans le navigateur :
           il ne doit pas déclencher d'aller-retour serveur. */
        if (e.target.matches('[data-avail-filter]')) return;
        applyFacets(form);
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        applyFacets(form);
      });
    }

    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        url.searchParams.delete('page');
        navigate(url.toString());
      });
    }

    initPriceRange();
  }

  function applyFacets(form) {
    var data = new FormData(form);
    var params = new URLSearchParams();
    data.forEach(function (value, key) {
      if (value !== '' && value !== null) params.append(key, value);
    });
    var url = new URL(window.location.pathname, window.location.origin);
    var qs = params.toString();
    navigate(url.pathname + (qs ? '?' + qs : ''));
  }

  function navigate(url) {
    var section = $('[data-collection-results]');
    if (!section) { window.location.href = url; return; }
    section.style.opacity = '.45';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newResults = doc.querySelector('[data-collection-results]');
        var newFacets = doc.querySelector('[data-facets-form]');
        var currentFacets = $('[data-facets-form]');
        var checkedAvail = getAvailabilityStates();
        if (newResults) section.innerHTML = newResults.innerHTML;
        if (newFacets && currentFacets) {
          var wasOpen = $$('.facets__group.is-open', currentFacets).map(function (g) { return g.getAttribute('data-facet-index'); });
          currentFacets.innerHTML = newFacets.innerHTML;
          wasOpen.forEach(function (idx) {
            var g = currentFacets.querySelector('.facets__group[data-facet-index="' + idx + '"]');
            if (g) g.classList.add('is-open');
          });
          checkedAvail.forEach(function (v) {
            var i = currentFacets.querySelector('[data-avail-filter][value="' + v + '"]');
            if (i) i.checked = true;
          });
          initPriceRange();
        }
        window.history.replaceState({}, '', url);
        section.style.opacity = '';
        initCarousels();
        applyCollectionView();
        applyAvailabilityFilter();
      })
      .catch(function () { window.location.href = url; });
  }

  function initPriceRange() {
    $$('[data-price-range]').forEach(function (range) {
      var min = $('[data-price-min]', range);
      var max = $('[data-price-max]', range);
      var minInput = $('[data-price-min-input]', range);
      var maxInput = $('[data-price-max-input]', range);
      var fill = $('.price-range__fill', range);
      if (!min || !max) return;

      function update() {
        var lo = Math.min(parseFloat(min.value), parseFloat(max.value));
        var hi = Math.max(parseFloat(min.value), parseFloat(max.value));
        var span = parseFloat(min.max) - parseFloat(min.min) || 1;
        if (fill) {
          fill.style.left = ((lo - parseFloat(min.min)) / span * 100) + '%';
          fill.style.width = ((hi - lo) / span * 100) + '%';
        }
        if (minInput) minInput.value = Math.round(lo);
        if (maxInput) maxInput.value = Math.round(hi);
      }
      function commit() {
        var form = range.closest('form');
        if (form) applyFacets(form);
      }

      min.addEventListener('input', update);
      max.addEventListener('input', update);
      min.addEventListener('change', commit);
      max.addEventListener('change', commit);
      if (minInput) minInput.addEventListener('change', function () { min.value = minInput.value; update(); commit(); });
      if (maxInput) maxInput.addEventListener('change', function () { max.value = maxInput.value; update(); commit(); });
      update();
    });
  }

  /* ---------- Charger plus de produits ---------- */
  function initLoadMore() {
    onGlobal('loadmore-click', document, 'click', function (e) {
      var btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      var url = btn.getAttribute('href');
      if (!url) return;
      btn.classList.add('is-loading');
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newItems = doc.querySelectorAll('[data-product-grid] > li');
          var grid = $('[data-product-grid]');
          if (grid) {
            newItems.forEach(function (li) { grid.appendChild(li); });
          }
          var newBtn = doc.querySelector('[data-load-more]');
          var wrap = btn.parentElement;
          if (newBtn && wrap) {
            btn.setAttribute('href', newBtn.getAttribute('href'));
          } else if (wrap) {
            wrap.remove();
          }
          window.history.replaceState({}, '', url);
          initWishlistState();
          applyAvailabilityFilter();
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* ---------- Favoris (stockage local) ---------- */
  var WISHLIST_KEY = 'ca_wishlist';
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch (e) { return []; }
  }
  function setWishlist(list) {
    try { localStorage.setItem(WISHLIST_KEY, JSON.stringify(list)); } catch (e) { /* ignoré */ }
  }
  function initWishlistState() {
    var list = getWishlist();
    $$('[data-wishlist]').forEach(function (btn) {
      var handle = btn.getAttribute('data-wishlist');
      var active = list.indexOf(handle) > -1;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    $$('[data-wishlist-count]').forEach(function (el) {
      el.textContent = list.length;
      el.hidden = list.length === 0;
    });
  }
  function initWishlist() {
    onGlobal('wishlist-click', document, 'click', function (e) {
      var btn = e.target.closest('[data-wishlist]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-wishlist');
      var list = getWishlist();
      var idx = list.indexOf(handle);
      if (idx > -1) {
        list.splice(idx, 1);
        toast(strings.wishlistRemoved || 'Retiré des favoris');
      } else {
        list.push(handle);
        toast(strings.wishlistAdded || 'Ajouté aux favoris');
      }
      setWishlist(list);
      initWishlistState();
    });
    initWishlistState();
  }

  /* ---------- Barre d'annonce mobile ---------- */
  function initAnnouncement() {
    var bar = $('[data-announcement]');
    if (!bar) return;
    if (bar.getAttribute('data-announcement-bound')) return;
    bar.setAttribute('data-announcement-bound', '1');
    var items = $$('.announcement-bar__item', bar);
    if (items.length < 2) return;
    var i = 0;
    items.forEach(function (it, k) { it.classList.toggle('is-active', k === 0); });
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4000);
  }

  /* ---------- Sélection de variante ---------- */
  function initVariants() {
    $$('[data-variant-selects]').forEach(function (root) {
      if (root.getAttribute('data-variants-bound')) return;
      root.setAttribute('data-variants-bound', '1');
      var form = root.closest('form') || document.querySelector('form[data-ajax-cart]');
      var idInput = form && form.querySelector('[name="id"]');
      var priceTarget = document.querySelector('[data-variant-price]');
      var variants = [];
      try { variants = JSON.parse(root.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }

      /* Affiche l'image propre à la variante. « position » est le rang du média
         dans product.media, et les diapositives sont rendues dans ce même ordre. */
      function applyVariantMedia(variant) {
        var media = variant && variant.featured_media;
        var pos = media && media.position;
        if (!pos) return;
        var gallery = $('[data-gallery]');
        if (gallery && typeof gallery.showIndex === 'function') gallery.showIndex(pos - 1);
      }

      /* Au chargement : respecte la variante déjà choisie (?variant=…). */
      if (idInput && idInput.value) {
        applyVariantMedia(variants.filter(function (v) {
          return String(v.id) === String(idInput.value);
        })[0]);
      }

      root.addEventListener('change', function () {
        var selected = $$('select, input:checked', root).map(function (el) { return el.value; });
        var match = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        })[0];
        if (!match) return;
        if (idInput) idInput.value = match.id;
        applyVariantMedia(match);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
        if (priceTarget) {
          priceTarget.innerHTML = formatMoney(match.price) +
            (match.compare_at_price > match.price ? ' <s class="price__compare">' + formatMoney(match.compare_at_price) + '</s>' : '');
        }
        var submit = form && form.querySelector('[type="submit"]');
        if (submit) {
          submit.disabled = !match.available;
          var label = submit.querySelector('[data-add-label]');
          if (label) label.textContent = match.available ? (strings.addToCart || 'Ajouter au panier') : (strings.soldOut || 'Rupture de stock');
        }
      });
    });
  }

  /* ---------- Filtre de disponibilité (côté navigateur) ----------
     Shopify ne connaît que « en stock » et « épuisé » : un produit réglé sur
     « continuer à vendre en cas de rupture » est compté comme en stock. Les
     cartes portent donc « data-availability » (in / preorder / out) calculé en
     Liquid, et le tri se fait ici, sur les produits chargés. */
  function getAvailabilityStates() {
    return $$('[data-avail-filter]').filter(function (i) { return i.checked; })
      .map(function (i) { return i.value; });
  }

  function applyAvailabilityFilter() {
    var grid = $('[data-product-grid]');
    var inputs = $$('[data-avail-filter]');
    if (!grid || !inputs.length) return;

    var items = $$(':scope > li', grid);
    var counts = { in: 0, preorder: 0, out: 0 };
    items.forEach(function (li) {
      var card = li.querySelector('[data-availability]');
      var state = card && card.getAttribute('data-availability');
      if (state && counts[state] !== undefined) counts[state]++;
    });

    $$('[data-avail-count]').forEach(function (el) {
      el.textContent = '(' + (counts[el.getAttribute('data-avail-count')] || 0) + ')';
    });
    inputs.forEach(function (i) { i.disabled = !i.checked && !counts[i.value]; });

    var wanted = getAvailabilityStates();
    var shown = 0;
    items.forEach(function (li) {
      var card = li.querySelector('[data-availability]');
      var state = card && card.getAttribute('data-availability');
      var visible = wanted.length === 0 || wanted.indexOf(state) > -1;
      li.style.display = visible ? '' : 'none';
      if (visible) shown++;
    });

    /* Mémoriser le choix dans l'adresse, pour qu'un lien partagé le rejoue. */
    var url = new URL(window.location.href);
    if (wanted.length) url.searchParams.set('dispo', wanted.join(','));
    else url.searchParams.delete('dispo');
    window.history.replaceState({}, '', url.toString());

    var group = $('[data-avail-group]');
    var countEl = $('.collection-toolbar__count');
    if (countEl) {
      if (countEl.getAttribute('data-original') === null) {
        countEl.setAttribute('data-original', countEl.textContent.trim());
      }
      if (wanted.length && group) {
        var word = shown > 1
          ? (group.getAttribute('data-label-other') || 'produits affichés')
          : (group.getAttribute('data-label-one') || 'produit affiché');
        countEl.textContent = shown + ' ' + word;
      } else {
        countEl.textContent = countEl.getAttribute('data-original');
      }
    }

    var empty = $('[data-avail-empty]');
    if (empty) empty.style.display = (wanted.length && shown === 0) ? '' : 'none';
  }

  function initAvailabilityFilter() {
    /* Rejouer le choix présent dans l'adresse au chargement. */
    var fromUrl = new URL(window.location.href).searchParams.get('dispo');
    if (fromUrl) {
      fromUrl.split(',').forEach(function (v) {
        var i = $('[data-avail-filter][value="' + v + '"]');
        if (i) i.checked = true;
      });
    }
    onGlobal('avail-change', document, 'change', function (e) {
      if (!e.target.matches('[data-avail-filter]')) return;
      applyAvailabilityFilter();
    });
    applyAvailabilityFilter();
  }

  /* ---------- Style d'affichage des collections ---------- */
  var VIEW_MODE_KEY = 'ca_view_mode';
  var VIEW_COLS_KEY = 'ca_view_cols';
  function viewGet(key) { try { return localStorage.getItem(key); } catch (e) { return null; } }
  function viewSet(key, value) { try { localStorage.setItem(key, value); } catch (e) { /* ignoré */ } }

  function applyCollectionView() {
    var grid = $('[data-product-grid]');
    if (!grid) return;
    var mode = viewGet(VIEW_MODE_KEY) || grid.getAttribute('data-view-default') || 'grid';
    var cols = viewGet(VIEW_COLS_KEY) || grid.getAttribute('data-cols-default') || '';

    grid.classList.toggle('product-grid--list', mode === 'list');
    if (mode === 'list') grid.style.removeProperty('--cols');
    else if (cols) grid.style.setProperty('--cols', cols);

    var sw = $('[data-view-switch]');
    if (!sw) return;
    $$('[data-view-mode]', sw).forEach(function (b) {
      b.classList.toggle('is-active', b.getAttribute('data-view-mode') === mode);
      b.setAttribute('aria-pressed', b.getAttribute('data-view-mode') === mode ? 'true' : 'false');
    });
    $$('[data-view-cols]', sw).forEach(function (b) {
      b.classList.toggle('is-active', mode !== 'list' && b.getAttribute('data-view-cols') === String(cols));
      b.disabled = mode === 'list';
    });
  }

  function initCollectionView() {
    onGlobal('view-switch-click', document, 'click', function (e) {
      var mode = e.target.closest('[data-view-mode]');
      if (mode) {
        e.preventDefault();
        viewSet(VIEW_MODE_KEY, mode.getAttribute('data-view-mode'));
        applyCollectionView();
        return;
      }
      var cols = e.target.closest('[data-view-cols]');
      if (cols) {
        e.preventDefault();
        viewSet(VIEW_COLS_KEY, cols.getAttribute('data-view-cols'));
        viewSet(VIEW_MODE_KEY, 'grid');
        applyCollectionView();
      }
    });
    applyCollectionView();
  }

  /* ---------- Initialisation ---------- */
  function init() {
    initStickyHeader();
    initNav();
    initMobileMenu();
    initSearch();
    initCart();
    initQuantity();
    initCarousels();
    initGallery();
    initTabs();
    initFacets();
    initLoadMore();
    initWishlist();
    initAnnouncement();
    initVariants();
    initCollectionView();
    initAvailabilityFilter();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* Éditeur de thème Shopify */
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', init);
})();
